<template>
  <div id="app">
    <nav
      class="navbar navbar-custom navbar-fixed-top"
      role="navigation"
    >
      <div class="container-fluid">
        <div class="navbar-header">
          <button
            type="button"
            class="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#sidebar-collapse"
          >
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
          <router-link to="/">
            <a style="color: white" class="navbar-brand" href="#">
              <span style="color: #448AFF">SOLU</span>CASA
            </a>
          </router-link>

          <ul class="nav navbar-top-links navbar-left">
            <!-- <div class="profile-usertitle-name">{{user}}</div> -->

            <li class="dropdown" v-if="alerts.length">
              <a
                class="dropdown-toggle count-info"
                data-toggle="dropdown"
                href="#"
              >
                <em style="color: white" class="fa fa-bell"></em>
                <span class="label label-danger">{{
                  alerts.length
                }}</span>
              </a>

              <ul
                class="dropdown-menu dropdown-messages"
                style="height: 300px;
                      overflow: scroll;"
              >
                <div>
                  <div
                    class="col-md-12"
                    v-for="(alerta, index) in alerts"
                    :key="index"
                  >
                    <router-link
                      :to="{
                        name: 'editar-orden-servicio',
                        params: {
                          ordenId: alerta.alerta.split('#')[1],
                          proviene: 'general',
                        },
                      }"
                    >
                      <a href="#">
                        <p>
                          <b>{{ alerta.alerta }}</b>
                        </p>
                      </a>
                    </router-link>
                    <button
                      @click="eliminarAlerta(alerta.id, index)"
                      class="btn btn-danger btn-sm fa fa-trash"
                    ></button>
                    <li class="divider"></li>
                  </div>
                </div>
              </ul>
            </li>
          </ul>
          <ul class="nav navbar-top-links navbar-right">
            <!-- <div class="profile-usertitle-name">{{user}}</div> -->
            <li class="dropdown">
              <a
                class="dropdown-toggle count-info"
                data-toggle="dropdown"
                href="#"
              >
                <em style="color: white" class="fa fa-power-off"></em>
                <span class="label label-info"></span>
              </a>
              <ul class="dropdown-menu dropdown-alerts">
                <li>
                  <router-link to="/informacion">
                    <a href="#">
                      <div>
                        <em
                          style="color: black"
                          class="fa fa-at"
                        ></em>
                        Cuenta
                      </div>
                    </a>
                  </router-link>
                </li>

                <li>
                  <a href="#" @click="logOut">
                    <div>
                      <em
                        style="color: black"
                        class="fa fa-power-off"
                      ></em>
                      Salir
                    </div>
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
      <!-- /.container-fluid -->
    </nav>
    <div id="sidebar-collapse" class="col-sm-3 col-lg-2 sidebar">
      <div class="profile-sidebar">
        <div class="profile-userpic">
          <router-link to="/informacion">
            <img
              :src="
                image ||
                  'https://img.icons8.com/bubbles/100/000000/user.png'
              "
              class="img-responsive"
              alt
            />
          </router-link>
        </div>
        <div class="profile-usertitle">
          <div class="profile-usertitle-status">
            <span class="indicator label-success"></span>
            {{ usuario }}
          </div>
        </div>
        <div class="clear"></div>
      </div>
      <div class="divider"></div>
      <!-- <form role="search">
            <div class="form-group">
                <input type="text" class="form-control" placeholder="Buscar">
            </div>
      </form>-->
      <ul class="nav menu">
        <li>
          <router-link to="/">
            <a href="#">
              <em class="fa fa-cog">&nbsp;</em>Dashboard
            </a>
          </router-link>
        </li>
        <li v-if="rol === 'ADMIN_MAIN'">
          <router-link to="/informes">
            <a href="#">
              <em class="fa fa-file">&nbsp;</em>Informes
            </a>
          </router-link>
        </li>
        <li v-if="rol === 'ADMIN_MAIN'">
          <router-link to="/usuarios">
            <a href="#">
              <em class="fa fa-users">&nbsp;</em>Técnicos
            </a>
          </router-link>
        </li>
        <li v-if="rol === 'ADMIN_MAIN' || permisos.repuestos">
          <router-link to="/repuestos">
            <a href="#">
              <em class="fa fa-cogs">&nbsp;</em>Repuestos
            </a>
          </router-link>
        </li>
        <li v-if="rol === 'ADMIN_MAIN'">
          <router-link to="/marcas">
            <a href="#">
              <em class="fa fa-tasks">&nbsp;</em>Marcas
            </a>
          </router-link>
        </li>
        <li v-if="rol === 'ADMIN_MAIN' || permisos.tarjetas">
          <router-link to="/tarjetas">
            <a href="#"> <em class="fa fa-cog">&nbsp;</em>Equipos </a>
          </router-link>
        </li>
        <li>
          <router-link to="/clientes">
            <a href="#">
              <em class="fa fa-users">&nbsp;</em>Clientes
            </a>
          </router-link>
        </li>
        <li v-if="rol != 'ADMIN_MAIN'">
          <router-link to="/ordenes/personal">
            <a href="#">
              <em class="fa fa-book">&nbsp;</em>Mis ordenes de
              servicio
            </a>
          </router-link>
        </li>
        <li>
          <router-link to="/ordenes">
            <a href="#">
              <em class="fa fa-book">&nbsp;</em>Ordenes de servicio
            </a>
          </router-link>
        </li>
        <li>
          <router-link to="/ordenes/crear">
            <a href="#">
              <em class="fa fa-plus-square">&nbsp;</em>Crear orden de
              servicio
            </a>
          </router-link>
        </li>
        <li v-if="rol === 'ADMIN_MAIN'">
          <router-link to="/pagos">
            <a href="#"> <em class="fa fa-money">&nbsp;</em>Pagos </a>
          </router-link>
        </li>
      </ul>
    </div>
    <!--/.sidebar-->
    <loading
      :active.sync="loading"
      :can-cancel="false"
      :on-cancel="onCancel"
      loader="dots"
      color="#164880"
      :is-full-page="true"
    ></loading>
    <audio
      id="alerta"
      hidden
      src="https://firebasestorage.googleapis.com/v0/b/comercol-test.appspot.com/o/alerta.mp3?alt=media&token=d16cf761-bda1-44c4-aaba-8c1a195f9f29"
      preload="auto"
      controls
    ></audio>
    <div
      class="col-sm-9 col-sm-offset-3 col-lg-10 col-lg-offset-2 main"
    >
      <!--Inicio Renderizado de componentes-->
      <router-view></router-view>
      <!--Fin Renderizado de componentes-->

      <div class="col-sm-12">
        <p class="back-link">
          Solucasa &copy
          <a>{{ year }}</a>
        </p>
      </div>
    </div>
    <!--/.row-->
  </div>
</template>
<script>
import { mapState } from 'vuex';
import ServiceApi from '../ServiceApi';
import Loading from 'vue-loading-overlay';
// import WsSubscriptions from '../WsSubscriptions'

export default {
  name: 'dashboard',
  components: {
    Loading,
  },
  computed: mapState([
    'usuario',
    'rol',
    'image',
    'topicSocket',
    'alertas',
    'audio',
    'permisos',
    'usuarioId',
  ]),
  data() {
    return {
      alerts: [],
      loading: false,
      year: new Date().getFullYear(),
    };
  },
  watch: {
    audio() {
      // if(this.alertas.length > 0 ){
      //     var audio = document.getElementById('alerta')
      //     audio.play()
      // }
    },
    alertas() {
      if (this.alertas.length > 0) {
        this.alerts = this.alertas;
        var audio = document.getElementById('alerta');
        audio.play();
      }
    },
  },
  beforeCreate() {},
  async created() {
    // await WsSubscriptions()
  },
  mounted() {
    this.alerts = this.alertas;
    if (this.alerts.length) {
      var audio = document.getElementById('alerta');
      audio.play();
      this.$store.commit('SET_AUDIO', false);
    }
  },
  methods: {
    logOut() {
      this.loading = true;
      sessionStorage.clear();
      ServiceApi.get('/logout').then(response => {
        this.$store.commit('SET_LAYOUT', 'login');
        this.$store.commit('SET_LOGIN', false);
        this.$store.commit('SET_ROL', null);
        this.$store.commit('SET_USUARIO', null);
        this.$store.commit('SET_URL_IMAGE', null);
        this.$store.commit('SET_USUARIO_ID', null);
        this.$store.commit('SET_TOPIC_SOCKET', null);
        this.$store.commit('SET_ALERTAS', null);
        this.$store.commit('SET_PERMISOS_USER', null);
        //window.location.reload()
        this.loading = false;

        //Desconectar el socket
        // this.$ws.$emitToServer(`ALERTS:${this.usuarioId}`, 'close', {})
        this.$ws.$off(`ALERTS`);
        // this.$ws.removeSubscription()
        this.$router.push('/');
      });
    },
    eliminarAlerta(alertId, pos) {
      ServiceApi.post('/alert/delete', { alertId }).then(response => {
        this.alerts.splice(pos, 1);
        this.$store.commit('SET_ALERTAS', this.alerts);
      });
    },
    onCancel() {},
    listenEvents() {},
  },
};
</script>
